export const CommissioningClaimFormData = () => ({
  inputData: {
    installation_id:null,
    is_active: true,
    installation_items: [
      {
        forceSave: true,
        id: null,
        is_commissioning_item_claimed: false,
        commissioning_claim_by: null,
        commissioning_claim_remark: "",
      },
    ],
  },
});

export const createPageData = () => {
  const payload = {
    checkAfterSave: true,
    actionType: "checkInstallationClaim",
    modelName: "installations",
    relation: [
      {
        modelName: "installation_items",
        moduleAs: "installations_items",
        foreignKey: "installation_id",
      },
    ],
   
  };

  const navigatePage = { back: "/commissioning-claim-list" };

  const headerName = "Commissioning Claim";

  const validationType = "CommissioningClaim";
  const createEndpoint = "/updaterelationaldata";
  const getEndpoint = "/getCommissioningInstallationDetails";
 
  return {
    payload,
    navigatePage,
    headerName,
    createEndpoint,
    getEndpoint,
  };
};

export const exportPageData = {
  data: {
    modelName: "installation_commissioning_list_masters",
    listInstallation: true,
    contractor_id: null,
    assignedTo: null,
    status: "installation_completed",

    search: {
      searchKeyword: "",
      field_name: ["warehouse.warehouse_name", "contractor.first_name"],
    },
    pagination: { page: 1, pageSize: 100000 },
  },
  fileName: "commissioningClaimListData.xlsx",
};
